import React from 'react'

const StartOver = () => (
  <svg width="20" height="24" viewBox="0 0 20 24">
    <path fill="#232E83" fillRule="evenodd" stroke="#232E83" strokeWidth=".72" d="M12.15 3.176C6.586 2.797 1.753 7 1.354 12.566c-.4 5.566 3.785 10.384 9.348 10.763 3.192.217 6.144-1.075 8.155-3.268l-.06.065-1.34-1.25c-1.645 1.762-4.038 2.797-6.623 2.62-4.552-.31-7.976-4.252-7.65-8.805.327-4.554 4.281-7.993 8.832-7.683l-.197 2.748 4.841-3.352L12.346.427l-.197 2.749z"/>
  </svg>
)

export default StartOver
